import DocIcon from "../../assets/images/doc-icon.png";
import SheetIcon from "../../assets/images/sheet-icon.png";
import PPTIcon from "../../assets/images/ppt-icon.png";
import PDFIcon from "../../assets/images/pdf-icon.png";
import OtherFileIcon from "../../assets/images/other-file-icon.png";

export default function FileRender({ file }: any) {
  console.log(file)
  console.log(file?.filename)
  let iconImg = OtherFileIcon;
  if (file.type.includes("doc") || file.type.includes("word"))
    iconImg = DocIcon;
  if (file.type.includes("sheet") || file.type.includes("excel"))
    iconImg = SheetIcon;
  if (file.type.includes("powerpoint") || file.type.includes("presentation"))
    iconImg = PPTIcon;
  if (file.type.includes("pdf")) iconImg = PDFIcon;
  return (
    <div
      style={{
        minWidth: 150,
        height: 120,
        background: "#F7F7F7",
        padding: 20,
        borderRadius: 6,
      }}
    >
      <img src={iconImg} alt="type file" />
      <div className="mt-3">
        <a href={file?.path}>{file?.filename}</a>
      </div>
    </div>
  );
}
